import {
  createNgReactBridgeDirective,
  createNgReactBridgeFactory,
  createNgReactBridgeController
} from '../../react-bridge'
import { ApiAuthorizationServiceFactory } from '../api-keys/api-authorization.service'
import { OrganizationAPIKeyCtrl } from './organization-api-key.controller'
import { OrganizationApiKey } from '../../../components/keys-settings/organization-api-key'

createNgReactBridgeFactory(
  'apiAuthorizationService',
  ApiAuthorizationServiceFactory
)

export const organizationApiKeys = createNgReactBridgeDirective(
  'reactOrganizationApiKeys',
  [],
  OrganizationApiKey,
  ['apiKey', 'onRotateApiKey', 'role', 'checkRole']
)

createNgReactBridgeController('OrganizationAPIKeyCtrl', OrganizationAPIKeyCtrl)
